<template>
  <div> 
<md-card class="searchPanel">
  <md-card-content v-if="searchRequest">
      <div class="md-layout md-gutter">

        <div  v-if="active" class="md-layout-item md-size-20 md-small-size-30">
          <div ref = "refapptDateF" class = "inputBox">
            <datepicker v-model="searchRequest.apptDate.startDate">
              <label>Appt date</label>
            </datepicker>
          </div>
        </div>

        <div  v-if="active" class="md-layout-item md-size-20 md-small-size-30">
          <div ref = "refapptDateT" class = "inputBox">
            <datepicker v-model="searchRequest.apptDate.endDate">
              <label>To</label>
            </datepicker>
          </div>
        </div>

     
  

   <div  v-if="active" class="md-layout-item md-size-20 md-small-size-30">
   <div class = "inputBox" >
    <auto-complete-master-data-select
                                        group="REC_WINDOW"
                                        label="Rev. Windows"
                                        :preparedOptions="inbound_recwin"
                                        :init-value="searchRequest.receivingWindows"
                                        :on-item-changed="handleWindowsChanged"
                                        >
    </auto-complete-master-data-select>
  </div>
</div>

</div>   
 </md-card-content>

   <md-card-actions md-alignment="space-between">
    <div v-if="getPermission.ibslist.edit" class="md-layout-item md-size-100 md-small-size-100">
          <callingApiCenter path="/api/w/fsi/GetIBSInbound" :not-display-error="true">      
           
             <!-- <md-button class="custMenuButton md-raised" @click="doDownloadExcel" :disabled="!getDownloadCond"> Download </md-button> -->
             <!-- <input
             class="custSearchBar"
             type="text"
             placeholder="Searching Term"
             v-model="searchtermFilter"
             /> -->

             <div class="custButtonRight">
              <md-button class="md-raised custMenuButton md-primary" @click="doSearch">Search</md-button>
              <md-button class="md-raised custMenuButton" @click="doClear">Clear</md-button>
              <md-button class="md-icon-button" @click="mouseLeave" id="expand-button">
                <md-icon v-if="active == false">keyboard_arrow_down</md-icon>
                <md-icon v-if="active == true">keyboard_arrow_up</md-icon>
               </md-button>
             </div>

          </callingApiCenter>
      </div>
  </md-card-actions>
    

 
</md-card>


    <md-card class="data-table-container">
      <div class="outer-container">
        <div class="inner-container" style="display:flex; overflow:auto;">
          <div class="table-header">
            <table id="headertable">
                <th></th>
                <tr>
                  <th class="header-cell headerCenter1 w7"></th>
                </tr>
                <tr>
                  <th class="header-cell headerCenter1 w7"></th>
                </tr>

                <tr>
                  <td class="body-cell excelBox w7">No Shows</td>
                </tr>
                <tr>
                  <td class="body-cell excelBox w7">Inbound Loads</td>
                </tr>
                <tr>
                  <td class="body-cell excelBox w7">Detention</td>
                </tr>
                <tr>
                  <td class="body-cell excelBox w7">Flatbeds</td>
                </tr>
            </table>
          </div>
            <div v-for="(item, index) in getFSIDRToDisplay">
              
              <table id="bodytable">
                <tr>
                  <td class="body-cell excelBox w7" > {{ getDay(item.apptDate)  }}</td>
                </tr>
                <tr>
                  <td class="body-cell excelBox w7">{{ item.apptDate | date  }}</td>
                </tr>
                <tr>
                  <td class="body-cell excelBox w7">{{ item.sumNoshow }}</td>
                </tr>
                <tr>  
                  <td class="body-cell excelBox w7">{{ item.sumNormalR }}</td>
                </tr>
                <tr>
                  <td class="body-cell excelBox w7">{{ item.sumDetention }}</td>
                </tr>
                <tr>
                  <td class="body-cell excelBox w7">{{ item.sumFlatbedsR }}</td>
                </tr>
            </table> 
          </div>
        </div>
      </div>
    </md-card>
</div>
</template>


<style scoped>
@import '../../public/chris.css';
.excelBox {
  padding-top: 15px;
  padding-bottom: 15px;
  padding-left: 5px;
  padding-right: 5px;
  text-align: center;
}
.material-icons.md-18 { font-size: 18px; }
.material-icons.md-24 { font-size: 24px; }
.material-icons.md-36 { font-size: 36px; }
.material-icons.md-48 { font-size: 100px; }
.material-icons.md-light { color: rgba(255, 255, 255, 1); }
.material-icons.md-light.md-inactive { color: rgba(255, 255, 255, 0.3); }
.icons-center {
  vertical-align: middle;
  margin-right: 10px;
}
.inputBox {
  border: 1px solid #cacbcc;
  border-radius: 5px;
  color: #29303b;
  font-size: 18px;
  height: auto;
  line-height: 1.5em;
  padding: 5px 5px 5px 5px;
  margin-top: 5px;
}
.inputBox:hover {
  border: 2px solid #448aff;
  border-radius: 5px;
  color: #29303b;
  font-size: 18px;
  height: auto;
  line-height: 1.5em;
  padding: 6px 6px 6px 6px;
  margin-top: 5px;
  background-color: #e0eff7;
  
}
.tableW {
  height: 40px;
}
.center {
  text-align: center;
}
tr:hover {
  background: #c8e6f5;
}
.headerCenter1 {
  text-align: center;
  height: 45px;
}
.modal {
  background-color: #29303b;
  border-radius: 5px;
}
.modalTitle {
  font-weight: normal;
  font-family: 'UberMove', 'Open Sans', 'Helvetica Neue', Helvetica, sans-serif !important;
  font-weight: 500;
  color: white;
  font-family: Poppins, sans-serif;
  margin-bottom: 0.5rem;
  line-height: 1.6;
}
.md-menu {
  padding: 0;
  padding: 0;
}
.custButton {
  margin: 10px;
  width: 120px;
  height: 40px;
  line-height:40px;
  font-size: 0.8rem;
}
.custMenuButton {
  width: 110px;
  height: 40px;
  line-height:45px;
  font-size: 0.9rem;
  align-self: center;
}
.custButtonRight {
  margin: 3px;
  width: 300px;
  height: 40px;
  float: right;
}
.custButtonFilter{
  margin: 5px;
  width: 80px ;
  height: 30px ;
  font-size: 0.7rem ;
}
.custButtonFilterRight {
  margin: 5px;
  width: 200PX;
  height: 40px;
  float: right;
}
.inputBoxSpace {
    border: 1px solid #cacbcc;
    border-radius: 5px;
    color: #29303b;
    font-size: 18px;
    height: auto;
    width: 200px;
    line-height: 1em;
    padding: 5px 5px 5px 5px;
    margin-top: 6px;
  }
.inputBoxDouble {
    width: 400px;
    justify-content: space-around;
    display: flex;
  flex-direction: row;
  }
.inputBoxSpaceWide {
    border: 1px solid #cacbcc;
    border-radius: 5px;
    color: #29303b;
    font-size: 18px;
    height: auto;
    width: 400px;
    line-height: 1em;
    padding: 5px 5px 5px 5px;
    margin-top: 6px;
  }
  .result-included-outter-div {
    border: 1px solid #D0D0D0;
    border-radius: 5px;
    width: auto;
    padding: 10px;
    height: auto;
    margin-top: 5px;
    margin-bottom: 5px;
    margin-left: 20px;
}
.result-included-inner-div {
    margin-left: 5px;
    font-weight: bold;
    margin-bottom: -25px;
}
.result-included-div-span {
    margin-left: 100px; 
    margin-top: -10px;
}
.result-included-span {
    margin-left: 5px;
}

.result-included-inner-div-radio {
    margin-left: 5px;
    margin-bottom: -25px;
    margin: -12px;
}
.result-included-span-radio {
    font-weight: bold;
    margin-left: 12px;
    margin-right: 12px;
    position:relative;
    top: -5px;
}

</style>

<script>
/* eslint-disable no-plusplus */
import { mapGetters } from 'vuex';
import dateFormat from '../utils/dateFormat';
import api from "../api";
import parseXls from "../utils/parseXls";
import callingApiCenter from "../components/CallingApiCenter.vue";
import sort from "fast-sort";
import toGenerateExcelRequest, { downloadExcel } from "../utils/excel";

const getInitSearch = () => ({
  apptDate: {
    startDate: dateFormat.getLocalDateOnly(moment().startOf('month').toDate()),
    endDate: dateFormat.getLocalDateEnd(moment().endOf('d').toDate()),
  },
  receivingWindows: null,
  ibs_types: [],
  // inboundStatus: "R",
});

export default {
data: () => ({
  searchRequest: getInitSearch(),
  active: true,
  FSIDailyreport: [],
  items:[],
  searchtermFilter: "",
  inbound_recwin: [],
}),
components: {
  callingApiCenter,
},
watch: {
  getFSIDailyreport(val) {
    this.updateFSIDR(val);
  },
},
computed: {
...mapGetters([
    'getPermission',
    'getUserProfile',
    'getRole',
    'getFSIDailyreport',
    'getMasterDataByGroup',
  ]),
  getFSIDRToDisplay() {
   
    return this.mergeTable();

  },
   getDownloadCond() {
    // return this.FSIDailyreport.length > 0;
   },


},
async mounted() {
  const cachedSearchRequest = this.searchRequest;
  if (cachedSearchRequest && !_(cachedSearchRequest).isEmpty()) {
    this.searchRequest = JSON.parse(JSON.stringify(cachedSearchRequest));
  } else {
   this.searchRequest = getInitSearch(this);
  }
  console.log(`rec win: ${JSON.stringify(this.getMasterDataByGroup('REC_WINDOW').filter( it => it.tagName != 'STC'))}`);
  this.inbound_recwin = this.getMasterDataByGroup('REC_WINDOW').filter( it => it.tagName != 'STC');

},

 methods: {
    handleStatusChanged(id) {
      this.searchRequest.inboundStatus = id;
   },
   handleWindowsChanged(id) {
      this.searchRequest.receivingWindows = id;
    },
    mouseOver: function(){
      this.active = true;
    },
    mouseLeave: function() {
      this.active = !this.active;
    },
    updateFSIDR(FSIDailyreport) {
      var items = JSON.parse(JSON.stringify(FSIDailyreport));
      this.FSIDailyreport = items;

    },
    doSearch() {
      this.active = false;
      console.log("this.ibsoutbound:" + this.searchRequest);
      this.$nextTick(() => {
        this.$store.dispatch('FSIDRList', this.searchRequest);
      })
    },

    doClear() {
    this.$nextTick(() => {
      this.searchRequest = getInitSearch();
    });
    },
    handleScroll(e) {
       $(this.$el.querySelector('.table-body'))
       .offset({
          left: -1 * (e.target.scrollLeft - $('.outer-container')
           .offset().left),
      });
    },
    includeNull(field) {
      return field == null ? "" : field;
    },
   
    getDay(apptDate){
      const apptDay = dateFormat.getDayDisplay(apptDate);
      return apptDay;
    },

    mergeTable(){

      var item = 0;
      var sumNormalR = 0;
      var sumFlatbedsR = 0;
      var sumNoshow = 0;
      var sumDetention = 0;
      var newTable = [];
      
      const sortedFSIDailyreport = sort(this.FSIDailyreport).asc('apptDate'); 
      
      sortedFSIDailyreport.forEach((it, i, array) => {
       
       const comAppt = dateFormat.getLocalDateOnly(array[item].apptDate);
       const mergeAppt = dateFormat.getLocalDateOnly(it.apptDate);


      if ( comAppt == mergeAppt ){

          if( it.inboundStatus == 'R' && it.dockType == 'Normal'){
            sumNormalR ++ ;
          }
          if( it.inboundStatus == 'R' && it.dockType == 'Flat Bed'){
            sumFlatbedsR ++ ;
          }
          if( it.inboundStatus == 'N'){
            sumNoshow ++ ;
          }
          if( it.inboundStatus == 'R' && it.workIn != 'X' ){
             sumDetention = sumDetention + ( it.totalHours - 2 ) ; 
          }
          // console.log(`item: ${ item },  i: ${ i }`);
      
      
        }
      else{

         //  console.log(`-- else -- comDate: ${ comAppt }, mergeDate:${ mergeAppt }, item: ${ item },  i: ${ i }, ibs: ${ it.ibs }, sumR: ${ sumNormalR }`);
       
       var newCell = [];
       newCell['apptDate'] = comAppt;
       newCell['sumNormalR'] = sumNormalR;
       newCell['sumFlatbedsR'] = sumFlatbedsR;
       newCell['sumNoshow'] = sumNoshow;
       newCell['sumDetention'] = sumDetention;  
       newTable.push(newCell);       
      //  console.log(`push comDate: ${ comAppt }, mergeDate:${ mergeAppt }, newCell ${ newCell['apptDate'] }`);

       item = i;
      
       if( it.inboundStatus == 'R' && it.dockType == 'Normal') sumNormalR = 1 ;
       else sumNormalR = 0 ;

       if( it.inboundStatus == 'R' && it.dockType == 'Flat Bed') sumFlatbedsR = 1 ;
       else sumFlatbedsR = 0;

       if( it.inboundStatus == 'N') sumNoshow = 1 ; 
       else sumNoshow = 0;

       if ( it.inboundStatus == 'R' && it.workIn != 'X') sumDetention = it.totalHours - 2 ;
       else sumDetention = 0 ;

      }

       
      // console.log(`item: ${ item },  i: ${ i }, length: ${ array.length }`);
      
      if ( i ==  ( array.length - 1 ) ){
      //  console.log(`last one comDate: ${ comAppt }, mergeDate:${ mergeAppt }`);
       var newCell = [];
       newCell['apptDate'] =  mergeAppt;
       newCell['sumNormalR'] = sumNormalR;
       newCell['sumFlatbedsR'] = sumFlatbedsR;
       newCell['sumNoshow'] = sumNoshow;
       newCell['sumDetention'] = sumDetention;  
       newTable.push(newCell);    
      }


    });

      return newTable ;

    },
     

    doDownloadExcel(){
       const request = toGenerateExcelRequest(
          this.$el.querySelector('.data-table-container .inner-container'),
          'FSIDailyreport_Inbound.xls',
          1,
        );
        request.heads = _(request.heads).take(request.heads.length);
        request.rows = _(this.getFSIDRToDisplay)
        .map(item => [

            // getDay(item.apptDate),
            dateFormat.date(item.apptDate),
            item.sumNoshow,
            item.sumNormalR,
            item.sumDetention,
            item.sumFlatbedsR,

          ]);
        this.$store.dispatch('generateExcel', request)
          .then((res) => {
            window.open(res.url, 'blank');
      });
    },
  }
}
</script>